import * as React from "preact";
import { FunctionComponent } from "preact";
import SVGIcon from "../SVGIcon";

interface IFaqFeedbackCta {
  onClick?: VoidFunction;
}

const FaqFeedbackCta: FunctionComponent<IFaqFeedbackCta> = ({ onClick }) => {
  return <button type="button" className="faq-feedback-cta js-modal-trigger" onClick={onClick} data-target="#modal-FaqFeedbackModal">
    <SVGIcon name="feedback" className="faq-feedback-cta__icon" />
    <span className="faq-feedback-cta__text">Provide feedback on this answer</span>
  </button>;
};

export default FaqFeedbackCta;
